export const MenuItems =[
    {
        title :"Home",
        url :"/",
        cName :"nav-links"
    },
    {
        title :"About Us",
        url :"/aboutus",
        cName :"nav-links"
    },
    {
        title :"Contact Us",
        url :"/contactus",
        cName :"nav-links"
    },
    {
        title :"Login/Sign up",
        url :"/login",
        cName :"nav-links-mobile"
    },
 ];